import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    header: {
        background: '#E8E8E8',
        display: 'flex',
        alignItems: 'center',
        height: '49px',
        padding: '0px 0px 0 15px',
        '& h1': {
            padding: '0px 15px',
            fontSize: '22px',
            fontWeight: 600,
            lineHeight: '28.8px',
            color: '#2D4D95',
        },
    },
    gridHeader: {
        padding: '6px 15px',
        display: 'flex',
        flexFlow: 'wrap',
        alignItems: 'center',
        justifyContent: 'right',
        gap: '5px',
    },
    gridActions: {
        textAlign: 'right',
    },
    itemTypeFilter: {
        width: '220px',
    },
    inventorySearch: {
        width: '100%',
        height: '40px',
        boxSizing: 'border-box',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: '4px',
        backgroundColor: '#FFFFFF',
        padding: '0 10px',
        fontSize: '14px',
        color: '#4A4A4A',
        '& .MuiInputBase-input': {
            padding: '8px 6px',
            fontSize: '14px',
            lineHeight: '20px',
        },
        '& .MuiInputBase-input::placeholder': {
            color: 'rgba(0, 0, 0, 0.54)',
            opacity: 1,
        },
        '& .MuiInputAdornment-root, & > svg': {
            color: 'rgba(0, 0, 0, 0.54)',
        },
    },
    changeBtn: {
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        backgroundColor: '#454545',
        borderRadius: '6px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'capitalize',
        color: '#ffffff',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#5e5e5e',
        },
    },
    addIcon: {
        marginRight: '6px',
    },
    clearIcon: {
        cursor: 'pointer',
    },
    container: {
        padding: '0px 15px 15px',
    },
}));
